// Elimino las constantes no utilizadas para limpiar ESLint warnings

// Plan de Estudios UBA Derecho 2004
const PLAN_ABOGACIA_UBA_2004 = {
  orientaciones: {
    'Derecho Internacional Público': {
      id: 'Derecho Internacional Público',
      nombre: 'Derecho Internacional Público',
      requisitos: ['uba_21'], // Derecho Internacional Público
      puntos: {
        principales: 12,
        derivados: 8,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_fuentes_derecho_internacional',
            nombre: 'Las fuentes del Derecho Internacional',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Internacional Público'
          },
          {
            id: 'cpo_sujetos_jurisdicciones',
            nombre: 'Sujetos y Jurisdicciones',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Internacional Público'
          },
          {
            id: 'cpo_derecho_internacional_ddhh',
            nombre: 'Dcho. Internacional de los Dchos. Humanos',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Internacional Público'
          }
        ],
        derivadas: [
          {
            id: 'cpo_derecho_internacional_derivada_1',
            nombre: 'Materia Derivada Internacional Público 1',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Internacional Público - Derivada'
          },
          {
            id: 'cpo_derecho_internacional_derivada_2',
            nombre: 'Materia Derivada Internacional Público 2',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Internacional Público - Derivada'
          },
          {
            id: 'cpo_derecho_internacional_derivada_3',
            nombre: 'Materia Derivada Internacional Público 3',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Internacional Público - Derivada'
          },
          {
            id: 'cpo_derecho_internacional_derivada_4',
            nombre: 'Materia Derivada Internacional Público 4',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Internacional Público - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Económico Empresarial',
        'Departamento de Laboral',
        'Departamento de Penal',
        'Departamento de Privado',
        'Departamento de Público'
      ]
    },
    'Derecho Administrativo': {
      id: 'Derecho Administrativo',
      nombre: 'Derecho Administrativo',
      requisitos: ['uba_17'], // Elementos de Derecho Administrativo
      puntos: {
        principales: 12,
        derivados: 8,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_contratos_administrativos',
            nombre: 'Contratos Administrativos',
            creditos: 3,
            categoria: 'CPO Orientación Derecho Administrativo'
          },
          {
            id: 'cpo_procedimientos_recursos_administrativos',
            nombre: 'Procedimientos y Recursos Administrativos',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo'
          },
          {
            id: 'cpo_derecho_procesal_administrativo',
            nombre: 'Derecho Procesal Administrativo',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo'
          },
          {
            id: 'cpo_responsabilidad_estado',
            nombre: 'Responsabilidad del Estado',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo'
          },
          {
            id: 'cpo_potestad_reglamentaria_regulacion',
            nombre: 'Potestad Reglamentaria y Regulación',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo'
          },
          {
            id: 'cpo_organizacion_administrativa',
            nombre: 'Organización Administrativa',
            creditos: 1,
            categoria: 'CPO Orientación Derecho Administrativo'
          },
          {
            id: 'cpo_bases_derecho_administrativo',
            nombre: 'Las Bases del Derecho Administrativo',
            creditos: 1,
            categoria: 'CPO Orientación Derecho Administrativo'
          }
        ],
        derivadas: [
          {
            id: 'cpo_derecho_administrativo_derivada_1',
            nombre: 'Materia Derivada Derecho Administrativo 1',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo - Derivada'
          },
          {
            id: 'cpo_derecho_administrativo_derivada_2',
            nombre: 'Materia Derivada Derecho Administrativo 2',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo - Derivada'
          },
          {
            id: 'cpo_derecho_administrativo_derivada_3',
            nombre: 'Materia Derivada Derecho Administrativo 3',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo - Derivada'
          },
          {
            id: 'cpo_derecho_administrativo_derivada_4',
            nombre: 'Materia Derivada Derecho Administrativo 4',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Administrativo - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Económico Empresarial',
        'Departamento de Laboral',
        'Departamento de Penal',
        'Departamento de Privado',
        'Departamento de Público'
      ]
    },
    'Derecho del Trabajo': {
      id: 'Derecho del Trabajo',
      nombre: 'Derecho del Trabajo',
      requisitos: ['uba_18'], // Elementos de Derecho del Trabajo
      puntos: {
        principales: 16,
        derivados: 4,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_teoria_general_derecho_trabajo',
            nombre: 'Teoría General del Dcho. del Trabajo',
            creditos: 4,
            categoria: 'CPO Orientación Derecho del Trabajo'
          },
          {
            id: 'cpo_derecho_relaciones_colectivas',
            nombre: 'Derecho de las Relaciones Colectivas',
            creditos: 4,
            categoria: 'CPO Orientación Derecho del Trabajo'
          },
          {
            id: 'cpo_derecho_relaciones_individuales',
            nombre: 'Derecho de las Relaciones Individuales',
            creditos: 4,
            categoria: 'CPO Orientación Derecho del Trabajo'
          },
          {
            id: 'cpo_derecho_seguridad_social',
            nombre: 'Derecho de la Seguridad Social',
            creditos: 4,
            categoria: 'CPO Orientación Derecho del Trabajo'
          }
        ],
        derivadas: [
          {
            id: 'cpo_derecho_laboral_derivada_1',
            nombre: 'Materia Derivada Derecho Laboral 1',
            creditos: 2,
            categoria: 'CPO Orientación Derecho del Trabajo - Derivada'
          },
          {
            id: 'cpo_derecho_laboral_derivada_2',
            nombre: 'Materia Derivada Derecho Laboral 2',
            creditos: 2,
            categoria: 'CPO Orientación Derecho del Trabajo - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Económico Empresarial',
        'Departamento de Penal',
        'Departamento de Privado',
        'Departamento de Público'
      ]
    },
    'Derecho Penal': {
      id: 'Derecho Penal',
      nombre: 'Derecho Penal',
      requisitos: ['uba_15'], // Elementos de Derecho Penal
      puntos: {
        principales: 12,
        derivados: 8,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_teoria_delito_sistema_pena',
            nombre: 'Teoría del Delito y Sistema de la Pena',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Penal'
          },
          {
            id: 'cpo_regimen_proceso_penal',
            nombre: 'Régimen del Proceso Penal',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Penal'
          },
          {
            id: 'cpo_parte_especial_derecho_penal',
            nombre: 'Parte Especial del Derecho Penal',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Penal'
          },
          {
            id: 'cpo_criminologia',
            nombre: 'Criminología',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Penal'
          }
        ],
        derivadas: [
          {
            id: 'cpo_introduccion_teorias_criminologicas',
            nombre: 'Introducción a las Teorías Criminológicas',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Penal - Derivada'
          },
          {
            id: 'cpo_introduccion_parte_especial',
            nombre: 'Introducción a la Parte Especial',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Penal - Derivada'
          },
          {
            id: 'cpo_derecho_penal_derivada_3',
            nombre: 'Materia Derivada Derecho Penal 3',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Penal - Derivada'
          },
          {
            id: 'cpo_derecho_penal_derivada_4',
            nombre: 'Materia Derivada Derecho Penal 4',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Penal - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Económico Empresarial',
        'Departamento de Laboral',
        'Departamento de Privado',
        'Departamento de Público'
      ]
    },
    'Derecho Notarial': {
      id: 'Derecho Notarial',
      nombre: 'Derecho Notarial',
      requisitos: ['uba_23'], // Derecho de Familia y Sucesiones
      puntos: {
        principales: 12,
        derivados: 8,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_derecho_notarial',
            nombre: 'Derecho Notarial',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Notarial'
          },
          {
            id: 'cpo_derecho_registral',
            nombre: 'Derecho Registral',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Notarial'
          },
          {
            id: 'cpo_derecho_inmobiliario',
            nombre: 'Derecho Inmobiliario',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Notarial'
          }
        ],
        derivadas: [
          {
            id: 'cpo_derecho_notarial_derivada_1',
            nombre: 'Materia Derivada Derecho Notarial 1',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Notarial - Derivada'
          },
          {
            id: 'cpo_derecho_notarial_derivada_2',
            nombre: 'Materia Derivada Derecho Notarial 2',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Notarial - Derivada'
          },
          {
            id: 'cpo_derecho_notarial_derivada_3',
            nombre: 'Materia Derivada Derecho Notarial 3',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Notarial - Derivada'
          },
          {
            id: 'cpo_derecho_notarial_derivada_4',
            nombre: 'Materia Derivada Derecho Notarial 4',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Notarial - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Económico Empresarial',
        'Departamento de Laboral',
        'Departamento de Penal',
        'Departamento de Público'
      ]
    },
    'Derecho Tributario': {
      id: 'Derecho Tributario',
      nombre: 'Derecho Tributario',
      requisitos: ['uba_22', 'uba_24'], // Sociedades Civiles y Comerciales, Finanzas Públicas
      puntos: {
        principales: 12,
        derivados: 8,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_teoria_general_derecho_tributario',
            nombre: 'Teoría General del Dcho. Tributario',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Tributario'
          },
          {
            id: 'cpo_regimen_tributario_argentino',
            nombre: 'Régimen Tributario Argentino',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Tributario'
          },
          {
            id: 'cpo_procedimientos_recursos_tributarios',
            nombre: 'Procedimientos y Recursos Tributarios',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Tributario'
          }
        ],
        derivadas: [
          {
            id: 'cpo_derecho_tributario_derivada_1',
            nombre: 'Materia Derivada Derecho Tributario 1',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Tributario - Derivada'
          },
          {
            id: 'cpo_derecho_tributario_derivada_2',
            nombre: 'Materia Derivada Derecho Tributario 2',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Tributario - Derivada'
          },
          {
            id: 'cpo_derecho_tributario_derivada_3',
            nombre: 'Materia Derivada Derecho Tributario 3',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Tributario - Derivada'
          },
          {
            id: 'cpo_derecho_tributario_derivada_4',
            nombre: 'Materia Derivada Derecho Tributario 4',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Tributario - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Laboral',
        'Departamento de Penal',
        'Departamento de Privado',
        'Departamento de Público'
      ]
    },
    'Derecho Empresarial': {
      id: 'Derecho Empresarial',
      nombre: 'Derecho Empresarial',
      requisitos: ['uba_22', 'uba_24'], // Sociedades, Finanzas Públicas
      puntos: {
        principales: 12,
        derivados: 8,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_inst_navegacion_agua_aire',
            nombre: 'Inst. de la Navegación por Agua y Aire',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Empresarial'
          },
          {
            id: 'cpo_rec_naturales_prot_medio_ambiente',
            nombre: 'Rec. Naturales y Prot. del Medio Ambiente',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Empresarial'
          },
          {
            id: 'cpo_contratacion_mercantil',
            nombre: 'Contratación Mercantil',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Empresarial'
          },
          {
            id: 'cpo_titulos_credito_mercado_fin_cap',
            nombre: 'Títulos de Crédito, Mercado Fin. y de Cap.',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Empresarial'
          },
          {
            id: 'cpo_prop_ind_mercado_dcho_comp',
            nombre: 'Prop. Ind., Mercado y Dcho. de la Comp.',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Empresarial'
          }
        ],
        derivadas: [
          {
            id: 'cpo_derecho_empresarial_derivada_1',
            nombre: 'Materia Derivada Derecho Empresarial 1',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Empresarial - Derivada'
          },
          {
            id: 'cpo_derecho_empresarial_derivada_2',
            nombre: 'Materia Derivada Derecho Empresarial 2',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Empresarial - Derivada'
          },
          {
            id: 'cpo_derecho_empresarial_derivada_3',
            nombre: 'Materia Derivada Derecho Empresarial 3',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Empresarial - Derivada'
          },
          {
            id: 'cpo_derecho_empresarial_derivada_4',
            nombre: 'Materia Derivada Derecho Empresarial 4',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Empresarial - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Laboral',
        'Departamento de Penal',
        'Departamento de Privado',
        'Departamento de Público'
      ]
    },
    'Derecho Privado': {
      id: 'Derecho Privado',
      nombre: 'Derecho Privado',
      requisitos: ['uba_13'], // Contratos Civiles y Comerciales
      puntos: {
        principales: 12,
        derivados: 8,
        total: 20
      },
      materias: {
        principales: [
          {
            id: 'cpo_derecho_danos',
            nombre: 'Derecho de Daños',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Privado'
          },
          {
            id: 'cpo_derecho_consumidor',
            nombre: 'Derecho del Consumidor',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Privado'
          },
          {
            id: 'cpo_derecho_romano',
            nombre: 'Derecho Romano',
            creditos: 4,
            categoria: 'CPO Orientación Derecho Privado'
          }
        ],
        derivadas: [
          {
            id: 'cpo_derecho_privado_derivada_1',
            nombre: 'Materia Derivada Derecho Privado 1',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Privado - Derivada'
          },
          {
            id: 'cpo_derecho_privado_derivada_2',
            nombre: 'Materia Derivada Derecho Privado 2',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Privado - Derivada'
          },
          {
            id: 'cpo_derecho_privado_derivada_3',
            nombre: 'Materia Derivada Derecho Privado 3',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Privado - Derivada'
          },
          {
            id: 'cpo_derecho_privado_derivada_4',
            nombre: 'Materia Derivada Derecho Privado 4',
            creditos: 2,
            categoria: 'CPO Orientación Derecho Privado - Derivada'
          }
        ]
      },
      departamentosLibres: [
        'Departamento de Económico Empresarial',
        'Departamento de Laboral',
        'Departamento de Penal',
        'Departamento de Público'
      ]
    }
  },
  grupos: [
    {
      nombre: "Ciclo Básico Común (CBC)",
      categoria: "CBC",
      materias: [
        {
          id: "cbc_1",
          nombre: "Principios Generales del Derecho Latinoamericano",
          creditos: 4,
          categoria: "CBC",
          correlativas: [],
          level: 0
        },
        {
          id: "cbc_2",
          nombre: "Sociología",
          creditos: 4,
          categoria: "CBC",
          correlativas: [],
          level: 0
        },
        {
          id: "cbc_3",
          nombre: "Sociedad y Estado",
          creditos: 4,
          categoria: "CBC",
          correlativas: [],
          level: 0
        },
        {
          id: "cbc_4",
          nombre: "Introducción al Conocimiento de la Sociedad y el Estado",
          creditos: 4,
          categoria: "CBC",
          correlativas: [],
          level: 0
        },
        {
          id: "cbc_5",
          nombre: "Introducción al Pensamiento Científico",
          creditos: 4,
          categoria: "CBC",
          correlativas: [],
          level: 0
        },
        {
          id: "cbc_6",
          nombre: "Ciencia Política",
          creditos: 4,
          categoria: "CBC",
          correlativas: [],
          level: 0
        }
      ]
    },
    {
      nombre: "Ciclo Profesional Común (CPC) - 'Materias Blanquitas'",
      categoria: "CPC",
      materias: [
        {
          id: "uba_7",
          nombre: "Teoría General del Derecho",
          creditos: 4,
          categoria: "CPC",
          correlativas: [],
          level: 1
        },
        {
          id: "uba_8",
          nombre: "Teoría del Estado",
          creditos: 4,
          categoria: "CPC",
          correlativas: [],
          level: 1
        },
        {
          id: "uba_9",
          nombre: "Derechos Humanos y Garantías",
          creditos: 4,
          categoria: "CPC",
          correlativas: [],
          level: 1
        },
        {
          id: "uba_10",
          nombre: "Elementos de Derecho Constitucional",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_8"],
          level: 1
        },
        {
          id: "uba_11",
          nombre: "Elementos de Derecho Civil",
          creditos: 4,
          categoria: "CPC",
          correlativas: [],
          level: 1
        },
        {
          id: "uba_12",
          nombre: "Obligaciones Civiles y Comerciales",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_11"],
          level: 1
        },
        {
          id: "uba_13",
          nombre: "Contratos Civiles y Comerciales",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_12"],
          level: 1
        },
        {
          id: "uba_14",
          nombre: "Elementos de Derecho Procesal Civil y Comercial",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_12"],
          level: 1
        },
        {
          id: "uba_15",
          nombre: "Elementos de Derecho Penal y Procesal Penal",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_7", "uba_9"],
          level: 1
        },
        {
          id: "uba_16",
          nombre: "Elementos de Derechos Reales",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_12"],
          level: 1
        },
        {
          id: "uba_17",
          nombre: "Elementos de Derecho Administrativo",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_9", "uba_10", "uba_12"],
          level: 1
        },
        {
          id: "uba_18",
          nombre: "Elementos de Derecho del Trabajo",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_10", "uba_13"],
          level: 1
        },
        {
          id: "uba_19",
          nombre: "Elementos de Derecho Comercial",
          creditos: 4,
          categoria: "CPC",
          correlativas: ["uba_11"],
          level: 1
        },
        {
          id: "uba_20",
          nombre: "Elementos de Análisis Económico y Financiero",
          creditos: 4,
          categoria: "CPC",
          correlativas: [],
          level: 1
        }
      ]
    },
    {
      nombre: "CPO - Asignaturas Obligatorias Comunes - 'Materias Negritas'",
      categoria: "CPO Obligatoria Común",
      materias: [
        {
          id: "uba_21",
          nombre: "Derecho Internacional Público",
          creditos: 4,
          categoria: "CPO Obligatoria Común",
          correlativas: ["uba_9", "uba_10", "uba_13"],
          level: 2
        },
        {
          id: "uba_22",
          nombre: "Sociedades Civiles y Comerciales",
          creditos: 4,
          categoria: "CPO Obligatoria Común",
          correlativas: ["uba_13", "uba_19"],
          level: 2
        },
        {
          id: "uba_23",
          nombre: "Derecho de Familia y Sucesiones",
          creditos: 4,
          categoria: "CPO Obligatoria Común",
          correlativas: ["uba_13", "uba_16"],
          level: 2
        },
        {
          id: "uba_24",
          nombre: "Finanzas Públicas y Derecho Tributario",
          creditos: 4,
          categoria: "CPO Obligatoria Común",
          correlativas: ["uba_15", "uba_17", "uba_22"],
          level: 2
        },
        {
          id: "uba_25",
          nombre: "Derecho Internacional Privado",
          creditos: 4,
          categoria: "CPO Obligatoria Común",
          correlativas: ["uba_19", "uba_23"],
          level: 2
        }
      ]
    }
  ]
};

// Legacy export name for compatibility
const planCarreraAbogacia = PLAN_ABOGACIA_UBA_2004;

export default PLAN_ABOGACIA_UBA_2004;
export { planCarreraAbogacia };